import React, { useState, useRef, useEffect } from "react";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { 
      text: "Bonjour ! 👋 Bienvenue chez DOMOELEC. Notre équipe vous répondra rapidement ! ⚡", 
      isBot: true,
      timestamp: new Date()
    }
  ]);
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (inputMessage.trim()) {
      const newMessage = { 
        text: inputMessage, 
        isBot: false, 
        timestamp: new Date() 
      };
      setMessages(prev => [...prev, newMessage]);
      
      // Préparer le message pour WhatsApp
      const whatsappMessage = `Bonjour, je contacte DOMOELEC depuis le site web.

Message: ${inputMessage}

Merci pour votre attention.`;
      
      // Encoder le message pour l'URL
      const encodedMessage = encodeURIComponent(whatsappMessage);
      
      // Créer le lien WhatsApp
      const whatsappUrl = `https://wa.me/212661301243?text=${encodedMessage}`;
      
      // Ouvrir WhatsApp dans un nouvel onglet
      window.open(whatsappUrl, '_blank');
      
      // Message de confirmation
      setTimeout(() => {
        setMessages(prev => [...prev, { 
          text: "✅ Votre message a été envoyé vers WhatsApp ! Notre équipe vous répondra rapidement. 📱", 
          isBot: true,
          timestamp: new Date()
        }]);
      }, 500);
      
      setInputMessage("");
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('fr-FR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <>
      <div 
        className="chatbot-toggle" 
        onClick={toggleChatbot}
      
      >
        <img 
          src="/images/whats.png" 
          alt="WhatsApp Chat" 
          style={{ 
            width: '72px', 
            height: '72px', 
            objectFit: 'contain' 
          }} 
        />
      </div>
      
      {isOpen && (
        <div 
          style={{
            position: 'fixed',
            bottom: '100px',
            right: '20px',
            width: '350px',
            height: '500px',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1001,
            overflow: 'hidden'
          }}
        >
          {/* Header WhatsApp Style */}
          <div 
            style={{
              background: '#075E54',
              color: 'white',
              padding: '16px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div 
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px'
                }}
              >
                <img 
                  src="/images/whats.png" 
                  alt="DOMOELEC" 
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '16px' }}>DOMOELEC Support</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>En ligne</div>
              </div>
            </div>
            <button 
              onClick={toggleChatbot}
              style={{
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '20px',
                cursor: 'pointer',
                padding: '4px'
              }}
            >
              ✕
            </button>
          </div>

          {/* Messages Area */}
          <div 
            style={{
              flex: 1,
              padding: '16px',
              background: '#ECE5DD',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}
          >
            {messages.map((message, index) => (
              <div 
                key={index} 
                style={{
                  display: 'flex',
                  justifyContent: message.isBot ? 'flex-start' : 'flex-end',
                  marginBottom: '8px'
                }}
              >
                <div 
                  style={{
                    maxWidth: '80%',
                    padding: '10px 16px',
                    borderRadius: message.isBot ? '18px 18px 18px 4px' : '18px 18px 4px 18px',
                    background: message.isBot ? 'white' : '#DCF8C6',
                    color: '#333',
                    fontSize: '14px',
                    lineHeight: '1.4',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                    position: 'relative'
                  }}
                >
                  <div>{message.text}</div>
                  <div 
                    style={{
                      fontSize: '11px',
                      color: '#999',
                      marginTop: '4px',
                      textAlign: 'right'
                    }}
                  >
                    {formatTime(message.timestamp)}
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Area */}
          <div 
            style={{
              padding: '16px',
              background: 'white',
              borderTop: '1px solid #e0e0e0'
            }}
          >
            <form onSubmit={sendMessage} style={{ display: 'flex', gap: '8px' }}>
              <input 
                type="text" 
                placeholder="Tapez votre message..." 
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  border: '1px solid #ddd',
                  borderRadius: '25px',
                  outline: 'none',
                  fontSize: '14px'
                }}
              />
              <button 
                type="submit"
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#25D366',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px'
                }}
              >
                ➤
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
